import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/css/mobilefiltercss.css";
import FilterAllProduct from "../Filter/FilterAllProduct";
import {
  fetchProductList,
  clearFilters,
} from "../../../features/Product/redux/ProductList.slice";

const SidebarModal = ({ position = "left" }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { slug } = useParams();

  const selectedFilters = useSelector(
    (state) => state.product.selectedFilters
  );
  const handleApply = () => {
    const params = new URLSearchParams();

    Object.entries(selectedFilters).forEach(([key, value]) => {
      if (!value) return;

      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, v));
      } else {
        params.set(key, value);
      }
    });

    navigate(`/${slug}?${params.toString()}`);
    setShow(false);
  };

  const handleClear = () => {
    dispatch(clearFilters());
    navigate(`/${slug}`, { replace: true });
    dispatch(
      fetchProductList({
        slug,
        filters: {},
      })
    );
    setShow(false);
  };

  return (
    <>
      <Link
        to="#"
        className="filter-border"
        onClick={(e) => {
          e.preventDefault();
          setShow(true);
        }}
      >
        Filter <i className="bi bi-sliders"></i>
      </Link>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName={`sidebar-modal ${position === "right" ? "right" : "left"
          }`}
      >
        <Modal.Header closeButton>
          <Modal.Title>Filter</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <FilterAllProduct />
          
          <div className="sidebar-footer mt-3 d-flex justify-content-between">
            <Button variant="outline-dark" onClick={handleClear}>
              Clear
            </Button>

            <Button variant="dark" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SidebarModal;